"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return this * Math.PI / 180;
};

;


//////////////////
// WEBPACK FOOTER
// ./node_modules/map-nearest-location/dist/toRadiance.js
// module id = 187
// module chunks = 0